/* eslint-disable */
export default {
  conferenceCall: 'Conferenza telefonica',
  onHold: 'In attesa',
  ongoing: 'In corso',
  unknown: 'Sconosciuto',
  disconnected: 'Disconnessa',
  loading: 'Caricamento...',
  loadingTimeout: 'Timeout caricamento.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
